import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import config from "appConfig";
import { Modal, Button } from 'antd';
import { isMobileScreen, getWindowWidth } from './services/utils';
import { FacebookIcon, FacebookMessengerIcon, FacebookMessengerShareButton, FacebookShareButton, TwitterIcon, TwitterShareButton, ViberIcon, ViberShareButton, WhatsappIcon, WhatsappShareButton } from "react-share"
import styles from "./shareContext.scss"

const XIcon = ({ size }) => (
  <svg viewBox="0 0 64 64" width={size} height={size}><circle cx="32" cy="32" r="32" fill="#000000"></circle><path d="M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z" fill="white"></path></svg>
)

export const Context = createContext({
  shareState: {
    isVisible: false,
    isSuggested: false,
  },
  toggleShare: (params: any): void => { },
});

export interface ShareContextProps {
  children: React.ReactNode;
}

export const ShareContext = (props: ShareContextProps) => {
  const [shareState, setShareState] = useState({
    isVisible: false,
    isSuggested: false,
  });
  const isMobile = isMobileScreen(getWindowWidth());
  const optionalParams = useRef({
    url: window.location.href,
    title: window.document.title
  });

  const toggleShare = useCallback((params = {}) => {
    const { isSuggested, url, title } = params
    optionalParams.current = {
      url: url || window.location.href,
      title: title || window.document.title
    };

    setShareState(prevShareState => ({
      isVisible: !prevShareState.isVisible,
      isSuggested: isSuggested || false,
    })
    );
  }, []);

  return (
    <Context.Provider value={{ shareState, toggleShare }}>
      {props.children}

      <Modal
        visible={shareState.isVisible}
        width={isMobile ? "90%" : 700}
        title={shareState.isSuggested ? "Podijeli svoj oglas na društvenim mrežama?" : null}
        footer={shareState.isSuggested ? [
          <Button
            key="back"
            type="default"
            size="large"
            onClick={() => toggleShare()}
          >
            {"Preskoči"}
          </Button>
        ] : null}
        closable={true}
        onCancel={() => toggleShare()}
        maskClosable={true}
        destroyOnClose={true}
        style={{ top: "45%" }}
      >
        <div
          className={styles.shareButtonsWrapper}
          style={{
            justifyContent: isMobile ? "center" : "space-around",
            height: isMobile ? 32 : 64
          }}>

          <FacebookShareButton
            url={optionalParams.current.url}
          >
            <FacebookIcon round size={isMobile ? 32 : 64} />
          </FacebookShareButton>
          <FacebookMessengerShareButton
            url={optionalParams.current.url}
            appId={config.facebookAppId}

          >
            <FacebookMessengerIcon round size={isMobile ? 32 : 64} />
          </FacebookMessengerShareButton>
          <WhatsappShareButton
            url={optionalParams.current.url}
            title={optionalParams.current.title}
          >
            <WhatsappIcon round size={isMobile ? 32 : 64} />
          </WhatsappShareButton>
          <ViberShareButton
            url={optionalParams.current.url}
            title={optionalParams.current.title}
          >
            <ViberIcon round size={isMobile ? 32 : 64} />
          </ViberShareButton>
          <TwitterShareButton
            url={optionalParams.current.url}
            title={optionalParams.current.title}
          >
            <XIcon size={isMobile ? 32 : 64} />
          </TwitterShareButton>
        </div>

      </Modal>
    </Context.Provider>
  )
}




// WEBPACK FOOTER //
// ./src/ShareContex.tsx